(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("JSONFormsCore"), require("JSONFormsReact"));
	else if(typeof define === 'function' && define.amd)
		define("JSONFormsEditor", ["JSONFormsCore", "JSONFormsReact"], factory);
	else if(typeof exports === 'object')
		exports["JSONFormsEditor"] = factory(require("JSONFormsCore"), require("JSONFormsReact"));
	else
		root["JSONFormsEditor"] = factory(root["JSONFormsCore"], root["JSONFormsReact"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__51__, __WEBPACK_EXTERNAL_MODULE__336__) {
return 